<script setup lang="ts">
const user = useUser()
const adminTools = useAdminTools()

const toggleAdminTools = () => {
  adminTools.value = !adminTools.value
}
</script>

<template>
  <div v-if="user?.isAdmin" fixed left-4 bottom-16 gap-2 z-99 aria-label="asdasd">
    <AppButton
      variant="outline" :background-color="adminTools ? undefined : '#fbbf24'" class="!p-3"
      @click="toggleAdminTools()"
    >
      <div v-if="!adminTools" i-mdi:eye-outline color-brand-gray title="Enable Tools" />
      <div v-else i-mdi:eye-off-outline color-amber title="Disable Tools" />
    </AppButton>
  </div>
</template>
